import { useEffect, useRef } from "react";

export default function BouncingShrug() {
    const ref = useRef<HTMLDivElement | null>(null);

    const pos = useRef({ x: 100, y: 100 });
    const vel = useRef({ x: 2.5, y: 2 });

    useEffect(() => {
        let frame: number;

        const update = () => {
            const el = ref.current;
            if (!el) return;

            const rect = el.getBoundingClientRect();

            pos.current.x += vel.current.x;
            pos.current.y += vel.current.y;

            // bounce X
            if (
                pos.current.x <= 0 ||
                pos.current.x + rect.width >= window.innerWidth
            ) {
                vel.current.x *= -1;
                pos.current.x = Math.max(
                    0,
                    Math.min(pos.current.x, window.innerWidth - rect.width),
                );
            }

            // bounce Y
            if (
                pos.current.y <= 0 ||
                pos.current.y + rect.height >= window.innerHeight
            ) {
                vel.current.y *= -1;
                pos.current.y = Math.max(
                    0,
                    Math.min(pos.current.y, window.innerHeight - rect.height),
                );
            }

            el.style.transform = `translate(${pos.current.x}px, ${pos.current.y}px)`;

            frame = requestAnimationFrame(update);
        };

        frame = requestAnimationFrame(update);

        return () => cancelAnimationFrame(frame);
    }, []);

    return (
        <div
            ref={ref}
            translate="no"
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                fontSize: "80px",
                userSelect: "none",
                cursor: "default",
                willChange: "transform",
            }}
        >
            ¯\_(ツ)_/¯
        </div>
    );
}
